/*
 * Modal de registro de jornada: muestra StartTimeRecordForm o EndTimeRecordForm
 * segun si hay un worklog pendiente.
 */
import React, { useState } from 'react'
import { Modal, Spin, Button, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import StartTimeRecordForm from '../forms/startTimeRecordForm'
import EndTimeRecordForm from '../forms/endTimeRecordForm'
import { getPayload } from '../../../utils/auth'
import CreateTimeRecordForm from '../forms/CreateTimeRecordForm'
import { useActiveWorklog } from '../hooks/useActiveWorklog'

interface TimeRecordModalProps {
  initialOpen?: boolean
  onClose?: () => void
}

type ModalView = 'selector' | 'start' | 'create'

export const WORKLOG_ID_KEY = 'current_worklog_id'

const TimeRecordModal: React.FC<TimeRecordModalProps> = ({
  initialOpen = true,
  onClose
}) => {
  const PAYLOAD = getPayload()
  const { t } = useTranslation()
  const [open, setOpen] = useState(initialOpen)
  const [view, setView] = useState<ModalView>('selector')

  const { activeWorklog: pendingWorklog, loading: loadingById } = useActiveWorklog(PAYLOAD?.id)

  const handleCancel = () => {
    setOpen(false)
    onClose?.()
  }

  const ActionSelector: React.FC = () => (
    <Space direction='vertical' style={{ width: '100%' }} size='middle'>
      <Button
        type='primary'
        block
        shape='round'
        onClick={() => setView('start')}
      >
        {t('new_activity')}
      </Button>
      <Button
        block
        shape='round'
        onClick={() => setView('create')}
      >
        {t('finished_activity')}
      </Button>
    </Space>
  )

  const renderContent = () => {
    if (loadingById) return <Spin />

    if (pendingWorklog != null) {
      return (
        <EndTimeRecordForm
          worklogId={pendingWorklog.id}
          startTime={pendingWorklog.start_time}
          onCancel={handleCancel}
          onClose={handleCancel}
        />
      )
    }

    if (view === 'start') {
      return <StartTimeRecordForm
        onCancel={handleCancel}
        onClose={handleCancel}
        onBack={() => setView('selector')}
      />
    }

    if (view === 'create') {
      return (
        <CreateTimeRecordForm
          onCancel={handleCancel}
          onClose={handleCancel}
          onBack={() => setView('selector')}
        />
      )
    }

    return <ActionSelector />
  }

  return (
    <Modal
      open={open}
      title={t('time_record')}
      onCancel={handleCancel}
      onOk={handleCancel}
      footer={null}
      destroyOnClose
    >
      {renderContent()}
    </Modal>
  )
}

export default TimeRecordModal
